import { useState, useContext } from 'react'; 
import PageContext from './PageContext';
import TableInput from './TableInput'; 
import TableInputWithValue from './TableInputWithValueCopy.jsx';
import TableDropdownWithObj from './TableDropdownWithObjCopy.jsx';
import TableDatePicker from './TableDatePickerCopy.jsx';
import { TableCell } from '@mui/material';

const AddConsortiumGroupRow = ({row, count, tableHeader}) => {
    // get context from parent 
    const {
        groupDataList, 
        setGroupDataList, 
        groupDateListLength, 
        achAccountTypeList, 
        payoutMethodList,  
        addGroup, 
        consortiumGroupErrorList, 
        activeList
    } = useContext(PageContext);
    // initialize state
    const [groupId, setGroupId] = useState(''); 
    const [startDate, setStartDate] = useState(new Date()); 
    const [endDate, setEndDate] = useState(new Date()); 

    // get tag for columnname 
    const getTag = (columnName) => {
        // find tag for columnname
        for (let i = 0; i < tableHeader.length; i++) {
            if (tableHeader[i]['columnname'] == columnName) {
                return tableHeader[i]['columntag']; 
            }
        }
        // default return if tag not found
        return '';
    }

    // showCell to determine how to display each column
    const showCell = ( el ) =>{ 
        if (el === 'groupid') {
            return <TableInputWithValue tag='Group ID' value={groupId} setValue={setGroupId} objKey={'groupid'} list={groupDataList} setList={setGroupDataList} count={count} length={groupDateListLength} width='10vw'  overrideBlank={true} showError={consortiumGroupErrorList[count][el]}/>
        }
        else if (el === 'active') {
            return <TableDropdownWithObj tag='Status' objKey='active' optionsList={activeList} list={groupDataList} setList={setGroupDataList} count={count} length={groupDateListLength} width='5vw'  overrideBlank={true} showError={consortiumGroupErrorList[count][el]} />
        }
        else if (el === 'startdate') {
            return <TableDatePicker tag='Start Date' objKey={'startdate'} value={startDate} setValue={setStartDate} list={groupDataList} setList={setGroupDataList} count={count} length={groupDateListLength} disable={endDate} indicator={3} width='5vw'  showError={consortiumGroupErrorList[count][el]}/> 
        }
        else if (el === 'enddate') {
            return <TableDatePicker tag='End Date' objKey={'enddate'} value={endDate} setValue={setEndDate} list={groupDataList} setList={setGroupDataList} count={count} length={groupDateListLength} disable={startDate} indicator={4} width='5vw'  showError={consortiumGroupErrorList[count][el]}/>
        }
        else if (el === 'payoutmethodid') {
            return <TableDropdownWithObj tag='Payout Method' objKey='payoutmethodid' optionsList={payoutMethodList} list={groupDataList} setList={setGroupDataList} count={count} length={groupDateListLength} width='7vw'  overrideBlank={true} showError={consortiumGroupErrorList[count][el]}/>
        }
        else if (el === 'achaccounttype') {
            return <TableDropdownWithObj tag='ACH Account Type' objKey='achaccounttype' optionsList={achAccountTypeList} list={groupDataList} setList={setGroupDataList} count={count} length={groupDateListLength} width='8vw'  overrideBlank={true} showError={consortiumGroupErrorList[count][el]}/>
        }
        // no blank column for group
        else if (el !== 'blank'){
            return <TableInput tag={getTag(el)} objKey={el} list={groupDataList} setList={setGroupDataList} count={count} length={groupDateListLength} width='7vw'  overrideBlank={true} showError={consortiumGroupErrorList[count][el]} />
        }
    }

    return( 
        <>
            {/* map showCell function over ever column in the row */}
            {tableHeader.map(el => 
                <TableCell>{showCell(el['columnname'])}</TableCell>
            )}
        </>
    );
}

export default AddConsortiumGroupRow;